import { createFileRoute } from "@tanstack/react-router";
import { GameIndex, prepareGameIndex } from "@/features/game";
import { GamePending, GameRouteError } from "@/features/game/navigation";
import { gameResourceSearch } from "@/features/game/addresses";

export const Route = createFileRoute("/_site/unlisted/$coworld/$league/")({
  loaderDeps: ({ search }) => ({ resource: gameResourceSearch(search) }),
  shouldReload: ({ cause }) => cause !== "stay",
  loader: ({ context, location }) =>
    prepareGameIndex({ queryClient: context.queryClient, href: location.href }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  pendingComponent: GamePending,
  errorComponent: GameRouteError,
  component: GameIndex,
});
